import { useEffect, useRef } from "react";
import { motion, useInView, useMotionValue, useSpring, useTransform } from "framer-motion";

const AnimatedCounter = ({ to, suffix = "", prefix = "", duration = 1.6 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });
  const motionValue = useMotionValue(0);
  const springValue = useSpring(motionValue, { duration: duration * 1000, bounce: 0 });
  const rounded = useTransform(springValue, (v) => `${prefix}${Math.round(v).toLocaleString("en-US")}${suffix}`);

  useEffect(() => {
    if (isInView) motionValue.set(to);
  }, [isInView, to, motionValue]);

  return <motion.span ref={ref}>{rounded}</motion.span>;
};

export default AnimatedCounter;
